import React, { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

function WhatsAppButton() {
   const [isVisible, setIsVisible] = useState(false);
   const location = useLocation();
   const { t } = useTranslation();

   const messages = {
      "/fotografia-aerea": t("wamessages.quote"),
      "/grabacion-fpv": t("wamessages.quote"),
      "/drones-inmobiliaria": t("wamessages.fast_quote"),
      "/grabacion-eventos-dron": t("wamessages.fast_quote"),
      "/": t("wamessages.chat"),
   };

   const message = messages[location.pathname] || t("wamessages.chat");

   useEffect(() => {
      const handleScroll = () => {
         setIsVisible(window.scrollY > 300);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
         window.removeEventListener("scroll", handleScroll);
      };
   }, []);

   const openWhatsApp = () => {
      const phoneNumber = "615159344";
      const url = `https://wa.me/${phoneNumber}`;
      window.open(url, "_blank");
   };

   return (
      <div className={`whatsapp-container ${isVisible ? "active" : ""}`}>
         <span className={`whatsapp-text ${isVisible ? "visible" : ""}`}>
            {message}
         </span>

         <button
            className={`whatsapp-button ${isVisible ? "visible" : ""}`}
            onClick={openWhatsApp}
            disabled={!isVisible}
            aria-label="WhatsApp Button"
         >
            <FaWhatsapp />
            <div className="sm-red-dot"></div>
         </button>
      </div>
   );
}

export default WhatsAppButton;
